{
  "version": 1,
  "asset_id": "51e9583f-d28c-424d-b8d9-bec3110fcb40",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/51e9583f-d28c-424d-b8d9-bec3110fcb40/how-it-works-hero-960.jpg",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/51e9583f-d28c-424d-b8d9-bec3110fcb40/how-it-works-hero-960.jpg",
  "original_filename": "how-it-works-hero-960.jpg",
  "size": 75192,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T22:51:32Z"
}
